import React, { FC } from 'react';
import Lottie from 'lottie-react-web';

import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';

import {
  AnimationWrapper,
  CustomField,
  CustomLabel,
  CustomLink,
} from '../styled';
import Success from '../Success.json';

import Share from '../Share';

interface Props {
  txid: string;
  status: string;
}

const SuccessStatus: FC<Props & Queries.ThankYouCommonFragment> = ({
  txid,
  status,
  content,
  links,
}) => {
  return (
    <>
      <AnimationWrapper>
        <Lottie
          options={{
            animationData: Success,
            loop: false,
          }}
        />
      </AnimationWrapper>
      {txid && status && (
        <div style={{ textAlign: 'left' }}>
          <CustomLabel>{content?.labels?.transaction}</CustomLabel>
          <CustomField>{txid}</CustomField>
          <CustomLabel>{content?.labels?.status}</CustomLabel>
          <CustomField>{status}</CustomField>
        </div>
      )}
      <Paragraph align="left">{content?.description}</Paragraph>
      <Paragraph style={{ textAlign: 'left', paddingBottom: '48px' }}>
        {content?.moreInfoSuccess}
        <CustomLink href={links?.faq?.url}>{links?.faq?.title}</CustomLink>
      </Paragraph>
      <Share />
    </>
  );
};

export default SuccessStatus;
